<app-breadcrumb [title]="'Cart'|translate" [breadcrumb]="'Cart'|translate ">
</app-breadcrumb>


<!-- <div *ngIf="(cartItems$|async) as cartItems">
    <pre>
        {{cartItems | json}}
    </pre>
</div> -->


<!-- section start -->
<section class="cart-section section-b-space">
    <div class="container" *ngIf="(cartItems$|async) as cartItems; else noCartItem">


        <div class="row">
            <div class="col-sm-12">
                <table class="table cart-table table-responsive-xs">
                    <thead>
                        <tr class="table-head">
                            <th scope="col">{{'image'|translate}}</th>
                            <th scope="col">{{'Product name'|translate}} </th>
                            <th scope="col">{{'Price'|translate}} </th>
                            <th scope="col">{{'Quantity'|translate}} </th>
                            <th scope="col">{{'Delete'|translate}} </th>
                            <th scope="col">{{'Total'|translate}} </th>
                        </tr>
                    </thead>
                    <tbody *ngFor="let product of cartItems">
                        <tr [ngStyle]="{'border': product.quantitiesInCartItem>product.stock?'5px solid red':''}">
                            <td>
                                <a [routerLink]="['/shop/product/left/sidebar/', product.barcode]">
                                    <img [src]="product.imageName">
                                </a>
                            </td>
                            <td>
                                <a [routerLink]="['/shop/product/left/sidebar/', product.barcode]">{{
                                    product.productName | titlecase }}</a>
                                <div class="mobile-cart-content row">
                                    <div class="col-xs-3">
                                        <div class="qty-box">
                                            <div class="input-group">
                                                <input type="text" name="quantity" class="form-control input-number"
                                                    disabled [(ngModel)]="product.quantitiesInCartItem">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xs-3">
                                        <h2 class="td-color">
                                            {{ (product.unitPrice | discount:product) |
                                            currency:productService?.Currency.currency:'symbol' }}
                                        </h2>
                                    </div>

                                    <div class="col-xs-3">
                                        <h2 class="td-color">
                                            <a (click)="removeItem(product)" class="icon">
                                                <i class="ti-close"></i>
                                            </a>
                                        </h2>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <h2>
                                    {{ (product.unitPrice | discount:product) |
                                    currency:productService?.Currency.currency:'symbol' }}
                                </h2>
                            </td>
                            <td>
                                <div class="qty-box">
                                    <div class="input-group">
                                        <span class="input-group-prepend">
                                            <button type="button" class="btn quantity-left-minus" data-type="minus"
                                                (click)="decrement(product)">
                                                <i class="ti-angle-left"></i>
                                            </button>
                                        </span>
                                        <input type="text" name="quantity" class="form-control input-number" disabled
                                            [(ngModel)]="product.quantitiesInCartItem">
                                        <span class="input-group-prepend">
                                            <button type="button" class="btn quantity-right-plus" data-type="plus"
                                                (click)="increment(product)">
                                                <i class="ti-angle-right"></i>
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <button type="button" style="cursor: pointer;" (click)="removeItem(product)"
                                    class="icon">
                                    <i class="ti-close"></i>
                                </button>
                            </td>

                            <td>
                                <h2 class="td-color">
                                    {{ ((product.unitPrice | discount:product) * product.quantitiesInCartItem) |
                                    currency:productService?.Currency.currency:'symbol' }}
                                </h2>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table class="table cart-table table-responsive-md">
                    <tfoot>
                        <tr>
                            <td>{{'total price'|translate}} :</td>
                            <td>
                                <!-- <h2> {{ getTotal | async | currency:productService?.Currency.currency:'symbol'}}</h2> -->
                                <h2> {{ totalPrice| currency:productService?.Currency.currency:'symbol'}}</h2>

                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>

        <div class="row cart-buttons" *ngIf='cartItems.length'>
            <div class="col-6">
                <a [routerLink]="['/shop/product']" class="btn btn-solid">{{'continue shopping'|translate}}</a>
            </div>
            <div class="col-6">
                <a [routerLink]="['/shop/checkout']" class="btn btn-solid"
                    [ngClass]="{'disabled':disabledCheckOut}">{{'check out'|translate}}</a>
            </div>
        </div>
    </div>

    <ng-template #noCartItem>
        <div class="col-sm-12 empty-cart-cls text-center">
            <img src="assets/images/icon-empty-cart.png" class="img-fluid mb-4">
            <h3><strong>{{'Your Cart is Empty'|translate}}</strong></h3>
            <h4>{{'Add something to make me happy'|translate}}</h4>
        </div>
    </ng-template>


</section>
<!--section end-->